import { Permissions } from "../auth/permissions";

/**
 * Para onde cada usuário vai depois de entrar — e o destino do fallback de rota inválida.
 *
 * ⚠ Esta função existe para ser a ÚNICA fonte da regra. A causa raiz de o portal ter tido três
 * destinos diferentes de login (`/admin/profile` no SignIn, `/admin/timesheet` no layout, e o
 * dashboard escondido em `/admin/default`) foi a regra viver duplicada em dois arquivos. Corrigir
 * as strings sem centralizar faria o problema voltar na próxima rota nova.
 *
 * Decide por PERMISSÃO, não por papel: "quem tem a home" passou a ser exatamente "quem tem
 * `dashboard.view`", em vez de uma lista de papéis internos que precisava ser lembrada a cada
 * papel novo — foi assim que Finance ficou meses sem porta de entrada no portal.
 */
export const HOME_ROUTE = "/admin/home";
export const CLIENT_PORTAL_ROUTE = "/admin/client-portal";

export const PAINEIS_ROUTE = "/admin/paineis";
export const NEWS_ROUTE = "/admin/news";
export const PROFILE_ROUTE = "/admin/profile";

/**
 * Degraus em ordem de prioridade. Cada destino precisa ser uma rota registrada que exija a MESMA
 * permissão do degrau: mandar quem só tem `bi.view` ao portal do cliente caía numa tela em branco.
 * Sem nenhuma permissão conhecida, mantém o destino histórico (portal do cliente).
 */
const DEGRAUS: ReadonlyArray<readonly [string, string]> = [
  [Permissions.DashboardView, HOME_ROUTE],
  [Permissions.ClientPortalView, CLIENT_PORTAL_ROUTE],
  [Permissions.BiView, PAINEIS_ROUTE],
  [Permissions.NewsView, NEWS_ROUTE],
  [Permissions.EmployeesViewSelf, PROFILE_ROUTE],
];

export const homeRouteFor = (permissions: Iterable<string>): string => {
  const set = permissions instanceof Set ? permissions : new Set(permissions);
  return DEGRAUS.find(([permissao]) => set.has(permissao))?.[1] ?? CLIENT_PORTAL_ROUTE;
};
